import { memo } from "react";

import { Localized, useLocalization } from "@fluent/react";
import { Button, IconButton } from "@narmi/design_system";
import cc from "classcat";

import ShareIcon from "../components/ShareIcon";

import styles from "./NoLinkedAccounts.module.scss";

const LinkAccountButton = ({
  renderForScreen,
  onClick,
}: {
  renderForScreen: "s" | "m";
  onClick: () => void;
}) => {
  return (
    <div
      className={cc([
        styles.noExternalAccountsActionsLinkAnAccount,
        renderForScreen === "s" && styles.linkAccountButtonS,
        renderForScreen === "m" && styles.linkAccountButtonM,
      ])}
    >
      <Button kind="secondary" size="s" onClick={onClick}>
        <Localized id="external-accounts-actions-link-an-account">
          Link an account
        </Localized>
      </Button>
    </div>
  );
};

const NoLinkedAccounts = ({
  isVisible,
  onLinkAccount,
  onClose,
}: {
  isVisible: boolean;
  onLinkAccount: () => void;
  onClose: () => void;
}) => {
  const { l10n } = useLocalization();

  return (
    <>
      <div
        className={cc([
          styles.externalAccountsNoAccountsHeadingContainer,
          !isVisible && styles.externalAccountsNoAccountsHeadingContainerHidden,
        ])}
      >
        <ShareIcon />
        <div>
          <h4>
            <Localized id="external-accounts-no-accounts-container-header">
              Securely link external accounts
            </Localized>
          </h4>

          <p className={styles.externalAccountsNoAccountsSubheading}>
            <Localized id="external-accounts-no-accounts-container-subheading">
              Connect accounts from other banks to track balances and move funds
              effortlessly.
            </Localized>
          </p>
          <LinkAccountButton renderForScreen="s" onClick={onLinkAccount} />
        </div>
      </div>
      <div
        className={cc([
          styles.noExternalAccountsActions,
          !isVisible && styles.noExternalAccountsActionsHidden,
        ])}
      >
        <LinkAccountButton renderForScreen="m" onClick={onLinkAccount} />
        <IconButton
          kind="plain"
          label={l10n.getString(
            "external-accounts-no-accounts-dismiss-button-label"
          )}
          name="x"
          textSize="m"
          onClick={onClose}
        />
      </div>
    </>
  );
};

export default memo(NoLinkedAccounts);
